<mat-accordion>
  @for (question of $safeNavigationMigration(value?.questions) | filter: 'isActive' : true; track question.id; let i = $index) {
    <coin-customer-survey-question
      [index]="i"
      [question]="question"></coin-customer-survey-question>
  }
</mat-accordion>
